<div class="app-container">
	<div class="container__mainContent--loginBackground" *ngIf="isLoginRoute()">
		<router-outlet></router-outlet>
		<!-- <footer role="complementary">&copy; 2023 Ascendion. All Rights Reserved.</footer> -->
		<app-loader></app-loader>
	</div>
	
	<!-- <collab-comp-timeout (onTimeoutExpired)="onIdleTimeout()" (onLogout)="onLogout()" [idleDuration]="idleDuration" [idleWarningDuration]="idleWarningDuration">
	</collab-comp-timeout> -->
	
	<!-- <div *ngIf="isLandingRoute()"> -->
		<router-outlet></router-outlet>
	<!-- </div> -->
	
	<ng-container *ngIf="cookieService.showCookiePolicy">
		<app-policy-banner></app-policy-banner>
	</ng-container>
	
	<app-contact-us *ngIf="this.contactUsService.isContactUsShow"></app-contact-us>
</div>